@if (contentInfo) {
  <div>
    <div>
      <h2 class="bold">
        <span>
          {{count}}
        </span>

        <span class="content-list-headline">
          {{headline}}
        </span>
      </h2>
    </div>

    @if (contentInfo.curListContainer) {
      <app-object-content-list-regular
        [contentListContainer]="contentInfo.curListContainer"
        (objectRefresh)="setObjectRefresh($event)"
      ></app-object-content-list-regular>
    }

    @if (contentInfo.curContentListSource) {
      <app-object-content-list-source-array
        [contentListSource]="contentInfo.curContentListSource"
        (objectRefresh)="setObjectRefresh($event)"
      ></app-object-content-list-source-array>
    }
  </div>
}
